import { useCallback } from 'react'
import { useSyncHealthConnectData } from '@src/screens/Events/utils/useSyncHealthConnectData'
import { useSyncHealthKitOnRefresh } from './useSyncHealthKitOnRefresh'

export const useSyncHealthDataOnRefresh = (screen: 'home' | 'events') => {
  const syncHealthKit = useSyncHealthKitOnRefresh(screen)
  const syncHealthConnect = useSyncHealthConnectData()

  return useCallback(async () => {
    await Promise.all([syncHealthKit(), syncHealthConnect({ force: true })])
  }, [syncHealthKit, syncHealthConnect])
}
